import { render } from "./AppCoverages.vue?vue&type=template&id=058edf1d"
import script from "./AppCoverages.vue?vue&type=script&lang=js"
export * from "./AppCoverages.vue?vue&type=script&lang=js"

import "./AppCoverages.vue?vue&type=style&index=0&id=058edf1d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__